import { createSlice } from "@reduxjs/toolkit";
import { getCurrentSessionPages } from "../../utils/services/auth";
const UserSlice = createSlice({
  name: "user",
  initialState: {
    authInfo: null,
    accessibleRoutes: getCurrentSessionPages(),
    showSessionExpiry: false,
    sidebar: false,
    notificationCount: 0,
  },
  reducers: {
    setAuthInfo(state, action) {
      state.authInfo = action.payload;
    },
    setAccsibleRoutes(state, action) {
      state.accessibleRoutes = action.payload;
    },
    resetUserInfo(state, _) {
      state.authInfo = null;
      state.accessibleRoutes = getCurrentSessionPages();
    },
    setShowExpiryModal(state, action) {
      state.showSessionExpiry = action.payload;
    },
    setSidebar(state, action) {
      state.sidebar = action.payload;
    },
    setNotification(state, action) {
      state.notificationCount = action.payload;
    },
  },
});

export const { actions: userActions, reducer: UserReducer } = UserSlice;
